import { render, staticRenderFns } from "./contractChange.vue?vue&type=template&id=71c8bdbd&scoped=true&"
import script from "./contractChange.vue?vue&type=script&lang=js&"
export * from "./contractChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8bdbd",
  null
  
)

export default component.exports